import { useStore } from '@/store'

export default nuxtApp => {
  const { $pinia } = nuxtApp
  const store = useStore($pinia)
  const apiPath = '/api/help-center'

  return {
    async get (path, params = {}, redirectOnError = true) {
      const { lang, token, config } = store
      return await $fetch(`${config.platformUrl}${apiPath}/${lang}/${path}`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`
        },
        onResponseError ({ request, response, options }) {
          if (redirectOnError) showError({ statusCode: response?.status })
        }
      })
    },
    getArticleById (id) {
      return this.get(`article/${id}`)
    },
    getCategories () {
      return this.get('categories')
    },
    getCategoryById (id) {
      return this.get(`category/${id}`)
    },
    getSearchResults (params) {
      return this.get('search', params)
    },
    getSupportInformation (params) {
      return this.get('support', params, false)
    }
  }
}
